import authenticationApi from "./authentication/api";
import authentication from './authentication/router';

import accountApi from "./account/api";
import account from './account/router';

import factoryApi from "./factory/api";
import factory from './factory/router';


let mergeing = {...authentication, ...factory, ...account }

let components = []
let actions = {}
let accChildren = []
let roles = 'public'

if (localStorage.account) {
    if (JSON.parse(localStorage.account).user) {
        roles = JSON.parse(localStorage.account).user.roles
    }
}

Object.keys(mergeing).map(component => {
    let el = mergeing[component]
    if (!el) return
    if (!el.meta.roles.includes(roles)) return false;

    if (el.path) {
        components.push({
            path: el.path,
            name: el.name,
            component: el.component,
        })
    } else {

        if (el.action) {
            el.actions.map(child => {
                if (child.meta.roles.includes(roles)) {
                    if (!actions[child.scope]) {
                        actions[child.scope] = []
                    }
                    actions[child.scope].push(child)
                }
            })
        }

        el.children.map(child => {
            if (child.meta.roles.includes(roles)) {
                if (child.path.includes('profile')) {
                    accChildren.push(child)
                }

            }
        })

    }

})

if (accChildren.length > 0) {
    let x = components.map(e => e.name).indexOf('CPanel');
    components[x].children = accChildren;
}


export default {
    api: {
        ...authenticationApi,
        ...factoryApi,
        ...accountApi,
    },
    actions: actions,
    routre: components,
}